"use strict";

var _objectWithoutProperties = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/objectWithoutProperties");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Layout = require("../../../../Layout");

var _Link = _interopRequireDefault(require("../../../../Link"));

var _MarkdownRenderer = _interopRequireDefault(require("../../../../MarkdownRenderer"));

var _NavItem = _interopRequireDefault(require("../../../../NavItem"));

var _MenuFooter = require("../MenuFooter.style");

var _FooterColumns = require("./FooterColumns.style");

var FooterColumns = function FooterColumns(_ref) {
  var columns = _ref.columns,
      rest = _objectWithoutProperties(_ref, ["columns"]);

  return /*#__PURE__*/_react.default.createElement(_Layout.Container, rest, /*#__PURE__*/_react.default.createElement(_Layout.Grid, {
    flexDirection: "row"
  }, columns.map(function (column) {
    var component = column.component,
        type = column.type;
    var columnWidths = {
      nav: [6, 6, 6, 6, 3],
      html: [12, 6, 6, 6, 3]
    };
    return /*#__PURE__*/_react.default.createElement(_Layout.Column, {
      key: "".concat(component.label, "_").concat(type),
      width: columnWidths[type]
    }, type && type === 'nav' && component.items && component.items.length > 0 && component.items.map(function (item, index) {
      var hasSubNav = item.navItems && item.navItems.length > 0;
      return (
        /*#__PURE__*/
        // eslint-disable-next-line react/no-array-index-key
        _react.default.createElement(_FooterColumns.FooterColumnNav, {
          key: "".concat(component.label, "_").concat(index)
        }, /*#__PURE__*/_react.default.createElement(_Link.default, {
          to: item.url
        }, /*#__PURE__*/_react.default.createElement(_NavItem.default, {
          label: item.label,
          onClick: item.onClick,
          enhanced: true
        })), hasSubNav && item.navItems.map(function (navItem) {
          return /*#__PURE__*/_react.default.createElement(_Link.default, {
            key: navItem.label,
            to: navItem.url,
            onClick: navItem.onClick
          }, /*#__PURE__*/_react.default.createElement(_NavItem.default, {
            description: null,
            label: navItem.label
          }));
        }))
      );
    }), type && type === 'html' && /*#__PURE__*/_react.default.createElement(_FooterColumns.FooterHtmlColumn, null, component.label && /*#__PURE__*/_react.default.createElement(_MenuFooter.FooterTitle, null, component.label), /*#__PURE__*/_react.default.createElement(_FooterColumns.FooterHtmlContainer, null, /*#__PURE__*/_react.default.createElement(_MarkdownRenderer.default, {
      html: component.html,
      copySize: "small"
    }))));
  })));
};

FooterColumns.propTypes = {
  columns: _propTypes.default.arrayOf(Object).isRequired
};
FooterColumns.defaultProps = {};
var _default = FooterColumns;
exports.default = _default;